import React from 'react'

function PrivacyPolicy() {


    return (
        <>

            <div className="row col-10 offset-1 py-5 d-flex justify-content-around">
                <h1 className='text-center py-5'>PrivacyPolicy for The C Learning Hub</h1>
            </div>

            <div>  <p className="row col-10 offset-1 py-1 d-flex justify-content-around">      This Application collects some Personal Data from its Users. Unless specified otherwise in this document, Personal Data shall be processed and stored for as long as required by the purpose they have been collected for and may be retained for longer due to applicable legal obligation or based on the Users’ consent.
            </p></div>

            <div className="row col-8 offset-2 py-1 d-flex justify-content-around">

                <div>
                    <p> <h3>Owner and Data Controller</h3></p>
                    <p> Rajasekhar Katakamsetty</p >
                    <p>  email: krs30018 @gmail.com</p>
                    <p>Goutham Nagar</p >
                    <p> Malkajgiri</p>
                    <p> Secunderabad 500047</p >
                    <p>India</p >
                </div>

                <div>  <h3>    Types of Data collected</h3>

                    <p>     Name, Email, Mobile Number, Address of the student</p></div>

                <div>  <h3>     Mode of processing</h3></div>


                <div>  <p>     The Owner takes appropriate security measures to prevent unauthorized access, disclosure, modification, or unauthorized destruction of the Data.
                    The Data processing is carried out using computers and/or IT enabled tools, following organizational procedures and modes strictly related to the purposes indicated.
                </p></div>

                <div>  <h3>    Place</h3></div>

                <div>  <p>       The Data is processed at the Owner's operating offices and in any other places where the parties involved in the processing are located.
                </p></div>

                <div>  <h3>     Retention time</h3></div>

                <div>  <p>       Unless specified otherwise in this document, Personal Data shall be processed and stored for as long as required by the purpose they have been collected for and may be retained for longer due to applicable legal obligation or based on the Users’ consent.
                </p></div>


            </div>
        </>
    )
}

export default PrivacyPolicy